import initialState from './initialState';
import {
  FETCH_COST_FILE_TEMPLATE,
  RECEIVE_COST_FILE_TEMPLATE,
  RECEIVE_COST_FILE_TEMPLATE_SAVE_STATUS,
  RECEIVE_COST_FILE_TEMPLATE_DELETE_STATUS,
  RESET_COST_FILE_TEMPLATE_DATA,
} from '../actions/costFileTemplateActions';
import { RECEIVE_ERROR_IN_COST_FILE_TEMPLATE } from '../actions/errorDialogActions';

export const COST_FILE_TEMPLATE_STATUS = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  FAILED: 'FAILED',
};

export const COST_FILE_TEMPLATE_EVENTS = {
  FETCH: 'FETCH',
  SAVE: 'SAVE',
  DELETE: 'DELETE',
};

const toTemplate = (response, suvc) => {
  const metadata = response?.costFileTemplateMetadata
    || response?.vendorCostFileTemplateMetadata || response?.templateMetadata || {};
  const header = response?.templateHeader || {};
  const templateId = metadata.id || metadata.templateId;
  if (!templateId) {
    return null;
  }
  return {
    templateId,
    templateName: metadata.templateName,
    suvc: metadata.suvc || suvc,
    optionalColumns: header.optionalColumns || [],
    orderedColumns: header.orderedColumns || [],
  };
};

// Responses for a SUVC that is no longer the requested one are ignored (stale responses)
const isStale = (state, data) => !data || data.suvc !== state.suvc;

export default function costFileTemplateReducer(state, { type, data }) {
  if (state === undefined) {
    return initialState.costFileTemplateData;
  }

  switch (type) {
    case FETCH_COST_FILE_TEMPLATE:
      return {
        ...initialState.costFileTemplateData,
        suvc: data.suvc,
        status: COST_FILE_TEMPLATE_STATUS.LOADING,
        receiveCount: state.receiveCount,
      };

    case RECEIVE_COST_FILE_TEMPLATE: {
      if (isStale(state, data)) {
        return state;
      }
      const header = data.response?.templateHeader || {};
      return {
        ...state,
        status: COST_FILE_TEMPLATE_STATUS.LOADED,
        template: toTemplate(data.response, data.suvc),
        mandatoryColumns: header.mandatoryColumns || [],
        event: COST_FILE_TEMPLATE_EVENTS.FETCH,
        receiveCount: state.receiveCount + 1,
      };
    }

    case RECEIVE_COST_FILE_TEMPLATE_SAVE_STATUS:
      if (isStale(state, data)) {
        return state;
      }
      return {
        ...state,
        template: toTemplate(data.response, data.suvc),
        event: COST_FILE_TEMPLATE_EVENTS.SAVE,
        receiveCount: state.receiveCount + 1,
      };

    case RECEIVE_COST_FILE_TEMPLATE_DELETE_STATUS:
      if (isStale(state, data)) {
        return state;
      }
      return {
        ...state,
        template: null,
        event: COST_FILE_TEMPLATE_EVENTS.DELETE,
        receiveCount: state.receiveCount + 1,
      };

    case RECEIVE_ERROR_IN_COST_FILE_TEMPLATE:
      return state.status === COST_FILE_TEMPLATE_STATUS.LOADING
        ? { ...state, status: COST_FILE_TEMPLATE_STATUS.FAILED }
        : state;

    case RESET_COST_FILE_TEMPLATE_DATA:
      return { ...initialState.costFileTemplateData, receiveCount: state.receiveCount };

    default:
      return state;
  }
}
